import axios from 'axios';

export function trackCommentary(
  url: string,
  source: string,
  data: Object,
): void {
  axios.post('/track_comment', { url, source, data });
}
